import { formatMAD, formatMoney } from '@xshop/shared';

// Spells an amount the way the checkout card does: dirhams in the theme's language, any other currency by Intl.
export const cartMoney = (amount: number, currency: string, direction: 'ltr' | 'rtl'): string =>
  (currency === 'MAD' ? formatMAD(amount, direction === 'rtl' ? 'ar-MA' : 'fr-MA') : formatMoney(amount, currency));
